<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row py-1">
                <div class="col-6">
                  <h5 class="mb-0">Model Log Management</h5>
                </div>
                <div class="col-6">
                  <div class="my-auto ms-auto float-end">
                    <button
                      type="button"
                      class="mx-1 mb-0 btn bg-gradient-dark btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#modalFilterModelLog"
                    >
                      filter
                    </button>
                    <button
                      type="button"
                      class="mx-1 mb-0 btn bg-gradient-dark btn-sm"
                      @click="exportToExcel"
                    >
                      Export to Excel
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div class="table-responsive" style="height: 500px">
              <table v-if="!table.onLoad" class="table">
                <thead class="table-primary">
                  <tr>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100 w-30">
                      User Code
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100 w-50">
                      Action
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100 w-45">
                      Auditable Type
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100 w-45">
                      IP Addres
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100 w-50">
                      Auditable ID
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100 w-50">
                      OLD Values
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100 w-50">
                      NOW Values
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder h-100">
                      Created at
                    </th>
                  </tr>
                </thead>
                <tbody v-if="table.dataLogs.length > 0">
                  <tr v-for="log in table.dataLogs" :key="log.id" class="align-middle">
                    <td class="text-sm py-3 px-4">{{ log.user_code }}</td>
                    <td class="text-sm py-3 px-4">{{ log.action }}</td>
                    <td class="text-sm py-3 px-4">{{ log.model }}</td>
                    <td class="text-sm py-3 px-4">{{ log.ip_address }}</td>
                    <td class="text-sm py-3 px-4">{{ log.model_id }}</td>
                    <td class="text-sm py-3 px-4">{{ log.old_values }}</td>
                    <td class="text-sm py-3 px-4">{{ log.new_values }}</td>
                    <td class="text-sm py-3 px-4">{{ formatDate(log.created_at) }}</td>
                  </tr>
                </tbody>
                <tbody v-else style="height: 300px">
                  <tr>
                    <td class="text-center align-middle" colspan="4">No Data</td>
                  </tr>
                </tbody>
              </table>
              <SkeletonLoading
                v-else
                class="px-4 pt-5"
                :shapes="[
                  { type: 'line', width: '100%', height: '20px' },
                  { type: 'line', width: '80%', height: '20px' },
                  { type: 'line', width: '60%', height: '20px' },
                ]"
              />
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination
                  v-model="table.page.current_pages"
                  :page-count="table.page.total_pages"
                  size="sm"
                  @click="changePage()"
                />
              </span>
              <span class="float-end">
                {{
                  (table.page.current_pages - 1) * table.page.per_pages +
                  table.dataLogs.length
                }}
                of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Filter -->
    <div id="modalFilterModelLog" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog mt-lg-5">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="ModalLabelFilterModelLog" class="modal-title">Filter</h5>
            <a class="text-dark" aria-hidden="true" data-bs-dismiss="modal" href="#">
              <i class="fa fa-close text-secondary"></i>
            </a>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label class="form-label">User</label>
                <input
                  v-model="modalFilterModelLog.data.user"
                  class="form-control"
                  type="text"
                  placeholder="Write the User"
                />
              </div>
              <div class="col-12">
                <label class="form-label">Action</label>
                <input
                  v-model="modalFilterModelLog.data.action"
                  class="form-control"
                  type="text"
                  placeholder="Write the Action"
                />
              </div>
              <div class="col-12">
                <label class="form-label">Model</label>
                <input
                  v-model="modalFilterModelLog.data.model"
                  class="form-control"
                  type="text"
                  placeholder="Write the Model"
                />
              </div>
              <div class="col-12">
                <label class="form-label">Model ID</label>
                <input
                  v-model="modalFilterModelLog.data.model_id"
                  class="form-control"
                  type="text"
                  placeholder="Write the Model ID"
                />
              </div>
              <div class="col-12">
                <label class="form-label">URL</label>
                <input
                  v-model="modalFilterModelLog.data.url"
                  class="form-control"
                  type="text"
                  placeholder="Write the URL"
                />
              </div>
              <div class="col-12">
                <label class="form-label">IP Address</label>
                <input
                  v-model="modalFilterModelLog.data.ip_address"
                  class="form-control"
                  type="text"
                  placeholder="Write the IP Address"
                />
              </div>
              <div class="col-12">
                <label class="form-label">User Agent</label>
                <input
                  v-model="modalFilterModelLog.data.user_agent"
                  class="form-control"
                  type="text"
                  placeholder="Write the User Agent"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              ref="closeModalFilterModelLog"
              type="button"
              class="btn bg-gradient-danger btn-sm"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn bg-gradient-primary btn-sm"
              :disabled="modalFilterModelLog.onLoad"
              @click="filterModelLog"
            >
              <span v-if="modalFilterModelLog.onLoad"
                ><i class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Please wait</span
              >
              <span v-else>Filter</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import api from "@/helpers/api";
import modelLogService from "@/services/report/appAuditing/modelLogService";
import moment from "moment";

export default {
  components: {
    BasePagination,
    SkeletonLoading,
  },
  data() {
    return {
      table: {
        onLoad: true,
        total: 0,
        dataLogs: [],
        page: {
          current_pages: 1,
        },
        loadTimeout: null,
      },
      modalFilterModelLog: {
        data: {
          user_code: "",
          action: "",
          model: "",
          model_id: "",
          url: "",
          ip_address: "",
          user_agent: "",
        },
        onLoad: false,
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;
      try {
        const response = await api(
          this,
          modelLogService.listModelLogs(
            this.table.page.current_pages,
            this.modalFilterModelLog.data
          ),
          false
        );
        this.table.total = response.data.total_items;
        this.table.dataLogs = response.data.data;
        this.table.page = response.data;
      } catch (error) {
        this.table.total = 0;
        this.table.dataLogs = [];
      } finally {
        this.table.onLoad = false;
      }
    },

    exportToExcel() {
      modelLogService
        .export()
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "models_losg.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Error exporting models logs:", error);
          alert("Gagal mengekspor data. Silakan coba lagi.");
        });
    },

    filterModelLog() {
      this.table.onLoad = true;
      this.modalFilterModelLog.onLoad = true;
      this.table.page.current_pages = 1;

      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        // Membangun query string untuk semua parameter pencarian
        const queryParams = {
          user_code: this.modalFilterModelLog.data.user_code || "",
          action: this.modalFilterModelLog.data.action || "",
          model: this.modalFilterModelLog.data.model || "",
          model_id: this.modalFilterModelLog.data.model_id || "",
          url: this.modalFilterModelLog.data.url || "",
          ip_address: this.modalFilterModelLog.data.ip_address || "",
          user_agent: this.modalFilterModelLog.data.user_agent || "",
        };

        // // Memasukkan query string ke dalam URL
        // const queryString = new URLSearchParams(queryParams).toString();

        this.$router.push({ name: 'Model Log', params: { moduleSlug: 'material-management' }, query: queryParams, });

        this.$refs.closeModalFilterModelLog.click();
        this.modalFilterModelLog.onLoad = false;
        this.get();
      }, 500);
    },

    changePage() {
      this.table.onLoad = true;

      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.get();
      }, 100);
    },
    formatDate(dateString) {
      return moment(dateString).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>

<style scoped>
/* Tambahkan style yang diperlukan di sini */
</style>
